export const formatFileSize = (value = 0) => {
  const toFixed = (val: number) => val.toFixed(2);
  if (!value) return "";
  if (value < 1024) {
    return `${value}B`;
  } else if (value < 1048576) {
    return `${toFixed(value / 1024)}K`;
  } else if (value < 1073741824) {
    return `${toFixed(value / 1048576)}M`;
  } else if (value < 1099511627776) {
    return `${toFixed(value / 1073741824)}G`;
  } else if (value < 1125899906842624) {
    return `${toFixed(value / 1099511627776)}T`;
  }
};

export const getCurrentPathList = (currentPath = "/"): INavPathItem[] => {
  if (currentPath === "" || !currentPath || currentPath === "/") {
    return [];
  }
  return currentPath
    .split("/")
    .slice(1)
    .map((v, i) => {
      if (i == -1) {
        return {
          label: "···",
          path: v,
        };
      } else {
        return {
          label: -1 < i ? v : "",
          path: v,
        };
      }
    });
};

export function convertWindowsPathToLinux(windowsPath: string): string {
  if (!windowsPath) {
    return "";
  }
  // Replace backslashes with forward slashes
  let linuxPath = windowsPath.replace(/\\/g, "/");

  // Replace the colon after the drive letter with an underscore
  linuxPath = linuxPath.replace(/^([a-zA-Z]):/, "/$1");

  // Remove the last segment (file name) from the path
  linuxPath = linuxPath.substring(0, linuxPath.lastIndexOf("/"));

  return linuxPath;
}
